listCacheDelete